<template>
  <router-view/>
</template>

<script>
import { onMounted } from 'vue';
import { useStore } from 'vuex';

export default {
    setup() {
      const store = useStore();
      onMounted( () => { store.dispatch('changeDevice') } );
  },
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }
</style>